// @tennis-matches/core/ui-globals
// Accessibility font size controls
// Used by all apps for consistent font size management

let __installed = false;

export function applyFontSize(state) {
  const size = state?.shared?.a11y?.fontSize || "m";
  document.documentElement.dataset.font = size;
}

export function installA11yFontSize({ getState, setState } = {}) {
  if (__installed) return;
  __installed = true;

  try {
    if (typeof getState === "function") {
      applyFontSize(getState());
    }
  } catch (_) {}

  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-a11y='font'] button");
    if (!btn) return;

    const size = btn.dataset.font;
    if (!size) return;

    if (typeof setState === "function") {
      setState(prev => ({
        ...prev,
        shared: {
          ...prev.shared,
          a11y: { fontSize: size }
        }
      }));
    }

    document.documentElement.dataset.font = size;
  });
}
